import { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';

const styles = {
  screen: {
    minHeight: '100vh',
    backgroundColor: '#0A2D5A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'system-ui, sans-serif',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: '40px',
    width: '100%',
    maxWidth: 400,
    boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
  },
  logo: {
    textAlign: 'center',
    marginBottom: 32,
  },
  brandName: {
    fontSize: 20,
    fontWeight: '700',
    color: '#0A2D5A',
    letterSpacing: 1,
  },
  tagline: {
    fontSize: 13,
    color: '#888',
    marginTop: 4,
  },
  label: {
    display: 'block',
    fontSize: 13,
    fontWeight: '600',
    color: '#444',
    marginBottom: 6,
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    borderRadius: 8,
    border: '1px solid #ddd',
    fontSize: 15,
    marginBottom: 16,
    boxSizing: 'border-box',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#E8620A',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: 8,
  },
  error: {
    backgroundColor: '#FEE2E2',
    color: '#CC0000',
    padding: '10px 14px',
    borderRadius: 8,
    fontSize: 13,
    marginBottom: 16,
  },
  divider: {
    height: 1,
    backgroundColor: '#eee',
    margin: '24px 0',
  },
  shield: {
    width: 48,
    height: 48,
    backgroundColor: '#E8620A',
    borderRadius: '8px 8px 20px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 12px',
    fontSize: 22,
    color: 'white',
  },
};

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

 const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      window.location.href = '/';
    } catch (err) {
      setError('Invalid email or password. Please try again.');
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    setError('');
    setMessage('');
    if (!email) {
      setError('Enter your email address above, then click Forgot password.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Password reset email sent. Check your inbox.');
    } catch (err) {
      setMessage('Password reset email sent. Check your inbox.');
    }
  };

  return (
    <div style={styles.screen}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <div style={styles.shield}>M</div>
          <div style={styles.brandName}>MEDICARE PLAN GUARDIAN</div>
          <div style={styles.tagline}>Agent Portal</div>
        </div>
        <div style={styles.divider} />
        {error && <div style={styles.error}>{error}</div>}
        {message && <div style={{ backgroundColor: '#DCFCE7', color: '#166534', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{message}</div>}
        <form onSubmit={handleLogin}>
          <label style={styles.label}>Email Address</label>
          <input
            style={styles.input}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
          <label style={styles.label}>Password</label>
          <input
            style={styles.input}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢"
            required
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <div onClick={handleForgotPassword} style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#1D6FA4', cursor: 'pointer', fontWeight: '600' }}>Forgot password?</div>
      </div>
    </div>
  );
}


